type ParsedCotenHost = {
  // `dewey` in `dewey.coten.app` or `dewey.coten.dev`, `lo` in `lo.coten.dev`
  app?: "dewey" | "lo";
  tld?: "dev" | "app";
  // empty when hostname is `dewey.coten.*` / `lo.coten.*`
  tenantSlug: string;
};

export const defaultTenantShortCode = "rollo";

export function parseCotenHostname(hostname: string): ParsedCotenHost {
  const host = hostname.toLowerCase();

  // Assumes ".coten." is constant.
  // - dewey.coten.app / dewey.coten.dev
  // - <tenant>.dewey.coten.app / <tenant>.dewey.coten.dev
  // - lo.coten.app / lo.coten.dev
  // - <tenant>.lo.coten.app / <tenant>.lo.coten.dev
  const m = host.match(/^(?:(?<tenant>[^.]+)\.)?(?<app>dewey|lo)\.coten\.(?<tld>dev|app)$/);
  if (!m?.groups) {
    return { tenantSlug: "" };
  }

  const app = m.groups["app"] as ParsedCotenHost["app"] | undefined;
  const tld = m.groups["tld"] as ParsedCotenHost["tld"] | undefined;
  const tenantSlug = (m.groups["tenant"] ?? "").trim();

  return { app, tld, tenantSlug };
}

export function buildTenantHost(params: { tenantShortCode: string; app: "dewey" | "lo"; tld: "dev" | "app" }): string {
  const { tenantShortCode, app, tld } = params;
  return tenantShortCode === defaultTenantShortCode ? `${app}.coten.${tld}` : `${tenantShortCode}.${app}.coten.${tld}`;
}
